var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-select',_vm._g(_vm._b({attrs:{"filter":"","items":_vm.states,"label":"status","label-icon":"icon-message","hide-details":"","dense":"","solo":""}},'app-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }